import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import iconX from '../assets/fi_x.svg';
import infoIcon from '../assets/fi_info.svg';
import suitcaseIcon from '../assets/fi_suitcase.svg';
import wheelIcon from '../assets/fi_wheel.svg';
import BaseButton from "./BaseButton";
import { useAuth } from "../context/AuthContext";
import etransportLogo from "../assets/etransport.png";
import MenuItems from "./Menu/MenuItems";

function UserMenu({ user, onSignOut, onCloseMenu }) {
    const dropdownRef = useRef();
    const navigate = useNavigate();

    const { logout } = useAuth();

    return (
        <div className="userMenuContainer">
            <div className={"header"}>
                <div className="userMenuContainer__header" ref={dropdownRef}>
                    <img className="header__logo" src={etransportLogo} alt="logo"/>
                    <span onClick={onCloseMenu}>
                    <img className="userMenuContainer__header--icon" src={iconX} alt="ico-x"/>
                </span>
                </div>
            </div>

            <div className="menuContent">
                <MenuItems onCloseMenu={onCloseMenu} />
                <div className={"separator"}></div>
                <div className={'userMenuButtons__middle'}>
                    <BaseButton
                        text="Apie mus"
                        className="baseButton--secondary"
                        icon={infoIcon}
                        handleOnClick={() => window.location.href = 'https://1424.lt/kontaktai/'}
                    />
                    <BaseButton
                        text="Verslui"
                        className="baseButton--secondary"
                        icon={suitcaseIcon}
                        handleOnClick={() => window.location.href = 'https://1424.lt/verslui/'}
                    />
                    <BaseButton
                        text="Tapk vairuotoju"
                        className="baseButton--secondary"
                        icon={wheelIcon}
                        handleOnClick={() => window.location.href = 'https://1424.lt/vairuotojo-darbas/'}
                    />
                </div>
                <div className={'userMenuButtons__bottom'}>
                    <BaseButton
                        text="Atsijungti"
                        handleOnClick={logout}
                        className="baseButton--primary"
                    />
                </div>
            </div>
        </div>
    );
}
export default UserMenu;